/**
*
* FaQs
*
*/

import React, { Fragment } from 'react';
import { AppWrappperHOC } from '../Root/HOC';
import BreadCrumb from '../../components/Breadcrumb';
import Container from '../../components/Container';
import WhiteBackground from '../../components/WhiteBackground';
import StyledFAQs from './StyledFAQs';
import { FAQ_LIST } from './constants';
import Accordion from '../../components/Accordion';

export const FaQs = () => (
  <Fragment>
    <BreadCrumb />
    <StyledFAQs>
      <Container>
        <WhiteBackground>
          <h2 className="hedding">Frequently Asked Questions</h2>
          {FAQ_LIST.map((item, id) => (<Accordion {...item} key={id} />))}
        </WhiteBackground>
      </Container>
    </StyledFAQs>
  </Fragment>
);

const component = AppWrappperHOC(FaQs);
export default component;



// WEBPACK FOOTER //
// client/containers/FaQs/index.js